import { useCallback } from 'react';
import useStepFlowStore from '@/stores/stepFlow/stepFlowStore';
import { CHATBOT_ONBOARDING_WORKFLOW_KEY } from '@/stores/stepFlow/chatbotOnboardingSteps';

const useChatbotOnboardingActions = (kbId) => {
  const key = kbId ? `${CHATBOT_ONBOARDING_WORKFLOW_KEY}:${kbId}` : null;

  const completeStepAndAdvance = useStepFlowStore((state) => state.completeStepAndAdvance);
  const currentStepId = useStepFlowStore((state) =>
    key ? state.flows[key]?.currentStepId : null
  );

  const completeCurrentStep = useCallback(async () => {
    if (!key || !currentStepId) return false;
    return completeStepAndAdvance(key, currentStepId, { successDurationMs: 3000 });
  }, [key, currentStepId, completeStepAndAdvance]);

  return { completeCurrentStep, currentStepId };
};

export default useChatbotOnboardingActions;
